import {Component, EventEmitter, Output, ViewChild} from "@angular/core";
import {NgbDateStruct, NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {VDateRange, Vessel} from "../../../shipper";
import {IsfDaterangePicker} from "../../isf.daterange.picker";
import {FormsModule} from "@angular/forms";
import {NgForOf} from "@angular/common";




export interface IsfFilterModel {
    status:string|null;
    importer:string|null;
    division:string|null;
    bill:string|null;
    container:string|null;
    description:string|null;
    vessel:string|null;
    mf:string|null;
    warehouse:string|null;
    reference:string|null;
    etaFrom:NgbDateStruct|null;
    etaTo:NgbDateStruct|null;
    createdFrom:NgbDateStruct|null;
    createdTo:NgbDateStruct|null;
    createdBy:string|null;
}

export class ISFListFilterData{

    status:Array<string>    = [];
    sa:Array<string>        = [];
    importer:Array<number>  = [];
    mid:Array<number>       = [];
    vessel:Array<number>    = [];
    division:Array<string>  = [];
    vesselTerm:string|null       = null;
    etaFrom:string|null          = null;
    etaTo:string|null            = null;
    dateRange:VDateRange    = "LAST_90";
    reference:string|null        = null;
    bill:string|null             = null;
    container:string|null        = null;
    description:string|null      = null;
    createdBy:string|null        = null;
    page: number            = 1;
    sort: string|null            = null;
    dir: string             = "DESC";


    constructor() {
        this.page = 0;
    }

    clear(){
        this.status     = [];
        this.sa         = [];
        this.importer   = [];
        this.mid        = [];
        this.vessel     = [];
        this.division   = [];
        this.vesselTerm = null;
        this.etaFrom    = null;
        this.etaTo      = null;
        this.dateRange  = "LAST_90";
        this.reference  = null;
        this.bill       = null;
        this.container  = null;
        this.description = null;
        this.createdBy  = null;
        this.page       = 1;
    }


    addImporter(id:number){
        if(!this.importer.includes(id)){ this.importer.push(id); }
    }

    addMid(id:number){
        if(!this.mid.includes(id)){ this.mid.push(id); }
    }

    addStatus(st:string){
        if(!this.status.includes(status)){ this.status.push(st); }
    }

    addVessel(id:number){
        if(!this.vessel.includes(id)){ this.vessel.push(id); }
    }

    removeImporter(id:number){
        this.importer = this.importer.filter((i) => i !== id);
    }

    removeMid(id:number){
        this.mid = this.mid.filter((i) => i !== id);
    }

    removeVessel(id:number){
        this.vessel = this.vessel.filter((i) => i !== id);
    }


    removeStatus(st:string){
        this.status = this.status.filter(i => i !== st);
    }

    public changeDir() {
        this.dir = (this.dir == "DESC") ? "ASC" : "DESC";
    }

    public resetPage(){
        this.page = 0;
    }

    public nextPage() {
        this.page++;
    }

    public prevPage() {
        this.page--;
    }


    getData(){
        let f = {};
        
        // @ts-ignore
        Object.keys(this).filter(i => this[i] !==null && this[i] !== "").forEach(i => f[i] = this[i]);

        return f;
    }
}


@Component({
    selector: "isf-filter",
    standalone: true,
    imports: [
        IsfDaterangePicker,
        FormsModule,
        NgForOf
    ],
    templateUrl: "isf.list.filter.html"
})
export class ISFListFilter{

    isfStatus:Array<string> = [
        "CREATED","TRANSMITTED","ACCEPTED","UPDATED","REJECTED","ERROR","DELETED"
    ];
    
    model = <IsfFilterModel>{};

    filterData:ISFListFilterData = new ISFListFilterData();

    @Output()
    searchEvent:EventEmitter<object> = new EventEmitter<object>();

    @Output()
    clearEvent:EventEmitter<object> = new EventEmitter<object>();

    //@ViewChild("saSelect",{static:true})
    //saSelect:SAStatusSelect;

    searchingImporter:boolean = false;

    searchingMid:boolean = false;

    searchingVessel:boolean = false;
    

    selectedVessels:Array<Vessel> = [];

    selectedStatus:Array<string> = [];
    


    /**
     *
     * @param isfSevice
     * @param im
     * @param mid
     */
    constructor() {}



    clear(){
        this.model = {
            importer: "",
            division: "",
            bill:"",
            container:"",
            description:"",
            mf:"",
            warehouse:"",
            reference: "",
            status: "",
            vessel: "",
            etaFrom: null,
            etaTo:null,
            createdFrom: null,
            createdTo: null,
            createdBy:""
        };
        
        this.selectedStatus     = [];
        

        this.filterData.clear();

        //this.saSelect.clear();

        this.clearEvent.emit(this.filterData.getData());
    }



    search(){
        this.searchEvent.emit(this.filterData.getData());
    }



    /**
     *
     * @param e
     */
    vesselSelected(e:NgbTypeaheadSelectItemEvent){
        e.preventDefault();

        this.filterData.addVessel(e.item.id);
        this.filterData.vesselTerm = this.model.vessel;

        if(!this.selectedVessels.find((i) => i.id == e.item.id)){
            this.selectedVessels.push(e.item);
        }

        //this.model.vessel = null;
    }


    /**
     *
     * @param ev
     */
    vesselTermSearch(ev:any){
        if(ev.target.value !== null && ev.target.value !==""){
            this.filterData.vesselTerm = ev.target.value;
        }
    }


    /**
     *
     * @param e
     */
    statusSelected(e:NgbTypeaheadSelectItemEvent){

        this.filterData.addStatus(e.item.status);

        if(!this.selectedStatus.find((i) => i == e.item.id)){
            this.selectedStatus.push(e.item);
        }
    }


    /**
     *
     * @param ev
     */
    statusChange(ev:any){
        // @ts-ignore
        this.filterData.status = [this.model.status];
    }
    
    
    divisionChange(ev:any){
        // @ts-ignore
        this.filterData.division = [this.model.division];
    }
    
    
    rangeChange(e:VDateRange){
        this.filterData.dateRange = e;
    }


    /**
     *
     */
    saStatusChange(sa:Array<string>){
        this.filterData.sa = sa;
    }
    
}
